import { createSelector } from 'reselect'

export const getProfileAdsQuery = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.ads && state.user.profile.ads.query
    ? state.user.profile.ads.query : {},
  query => query
)
